import {createFileRoute} from '@tanstack/react-router'
import {WalletSwapDex} from '@/components/wallet/WalletSwapDex/WalletSwapDex'

export const Route = createFileRoute('/_mainLayout/wallet/swap-dex/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WalletSwapDex />
}
